import theme from 'config/theme';
import {StyleSheet, Text, View} from 'react-native';

interface Props {
  name?: string;
}

export function CompatChip({name}: Props) {
  const label = name ?? 'null';
  return (
    <View style={styles.container}>
      {label && <Text style={styles.label}>{label}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.neutral.$11,
    paddingHorizontal: 8,
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    // @ts-ignore
    display: 'inline-flex',
    verticalAlign: 'middle',
    maxWidth: '100%',
  },
  label: {
    fontSize: 12,
    color: theme.colors.neutral.$2Base,
    lineHeight: 20,
    // @ts-ignore
    display: 'inline',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
